export class DesignationsRequest {
  designationId: number;
}